import CONFERENCEMEET from '../languages/zh-cn'
export let resCode = {
        1000:'无效的content-type',
        1001:'url not found',
        1100:'sid is empty',
        1101:'cid is empty',
        1102:'uid is empty',
        1103:'generate token failed',
        1106:'JOIN_ROOM_FAILER_OTHER',
        1104:'OPEN_RECORD_PERMISSION',
        1121:'JOIN_ROOM_FAILER_OTHER',
        1122:'JOIN_ROOM_FAILER_OTHER',
        1123:'access not exist',
        1131:'invalid session token',
        1132:'session token expired',
        1134:"sessiontoken doesn't match by room ",
        1135:'sessiontoken not exist',
        1140:'you are not compere',
        1141:'you are not owner',
        1200:'LOGIN_FAILER_INFO_ROOMEID_ISNOTEXIT',
        1210:'no roles in room',
        1211:'role name empty',
        1212:'same passcode between different rolos',
        1214:'role name invalid, need host or participant',
        1215:'host role config not found!',
        1216:'participant role config not found!',
        1217:'participant role config repeate!',
        1218:'participant role config repeate!',
        1219:'room name empty',
        1230:'compere need specify',
        1231:'compere is empty',
        1300:'time config invalid',
        1301:'LOGIN_FAILER_INFO_ROOMEID_ISNOTEXIT',
        // 1302:'meeting info invalid',
        // 1303:'meeting info invalid',
        1302:'LOGIN_FAILER_INFO_ROOMEID_ISNOTEXIT',
        1303:'LOGIN_FAILER_INFO_ROOMEID_ISNOTEXIT',
        1304:'uid not match',
        1400:'need passcode or sid',
        1401:'get roles map failed',
        1402:'invalid passcode',
        1403:'JOIN_ROOM_FAILER_OTHER',
        1404:'JOIN_ROOM_FAILER_OTHER',
        1405:'role not match',
        1407:'generate session token failed',
        1410:'ROOM_FULL_NAME',
        1411:'ROOM_FULL_NAME',
        1412:'ROOM_FULL_NAME',
        1408:'user name contains illegal characters',
        1800:'operaate mysql failed',
        1801:'operate redis failed',
        1802:'no mysql connection can use',
        1803:'load template failed',
        1804:'JOIN_ROOM_FAILER_OTHER',
        1805:'parse backend response error',
        1900:'internal app service error',
        1901:'invalid reqeust body',
        2000:'LOGIN_FAILER_INFO_ROOMEID_ISNOTEXIT',
        // 2000:'internal adapter service error',
        2001:'adapter service unvailable',
        2503:'stream not found',
        2504:'participant not found',
        2507:'bad request, checked by adapter',
        2508:'clould handle failed',
        3000:'cc service unvialable',
};
